export enum AssembleiaPautaStatus {
  Bloqueada = 0,
  Liberada = 1,
  Encerrada = 2,
}

export enum AssembleiaPautaStatusString {
  Bloqueada = 'BLOQUEADA',
  Liberada = 'LIBERADA',
  Encerrada = 'ENCERRADA',
}

export enum TipoVotoPauta {
  Vota = 'VOTA',
  Restrito = 'RESTRITO_NAO_VOTA',
  Colaborador = 'COLABORADOR_NAO_VOTA',
  VotaNaoColaborador = 'VOTA_SOMENTE_CONTA_NAO_COLABORADOR',
  SemPresenca = 'SEM_PRESENCA_MARCADA_NAO_VOTA',
  VotaNaoRestrito = 'VOTA_SOMENTE_CONTA_NAO_RESTRITO',
  QuorumOutroRepresentante = 'QUORUM_OUTRO_REPRESENTANTE',
}

export enum AssembleiaTipoPauta {
  Normal,
  Eleicao,
  Coordenador,
}

export const getNumberByAssembleiaPautaStatus = (param: string) => {
  switch (param) {
    case AssembleiaPautaStatusString.Bloqueada:
      return 0;
    case AssembleiaPautaStatusString.Liberada:
      return 1;
    case AssembleiaPautaStatusString.Encerrada:
      return 2;
    default:
      return null;
  }
};
